import { useTranslation } from "react-i18next";

import { InputRadio } from '../../InputRadio/Views/InputRadio';
import { ThemeType } from '../../../providers/MySettings/Types/theme';
import { useTheme } from '../../../providers/MySettings/Hooks/useTheme';

export const DisplaySection = () => {
  const { t } = useTranslation();
  const { currentTheme, setCurrentTheme } = useTheme();
  return (
    <div className="display-section" data-testid="display-section">
      <div className="my-settings__section-header">
        <div className="my-settings__section-title">{t("mySettings.display")}</div>
      </div>
      <div className="display-section__subtitle">{t("mySettings.theme")}</div>
      <div className="display-section__body">
        <div className="display-section__theme">
          <div
            className="display-section__theme-choice"
            onClick={() => setCurrentTheme(ThemeType.Dark)}
            data-testid="theme-dark-btn"
          >
            <div className="display-section__theme-item display-section__theme-item--dark">{t("mySettings.dark")}</div>
            <InputRadio
              name="theme-switch"
              value="dark"
              label={t("mySettings.dark")}
              isChecked={currentTheme === ThemeType.Dark}
              onChangeHandler={() => { }}
            />
          </div>
          <div
            className="display-section__theme-choice"
            onClick={() => setCurrentTheme(ThemeType.Light)}
            data-testid="theme-light-btn"
          >
            <div className="display-section__theme-item display-section__theme-item--light">{t("mySettings.light")}</div>
            <InputRadio
              name="theme-switch"
              value="light"
              label={t("mySettings.light")}
              isChecked={currentTheme === ThemeType.Light}
              onChangeHandler={() => { }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
